import { normalizePhoneFilterQuery } from '@/utils/phone'

// E.164 allows at most 15 digits, so a longer run of digits is a substring of
// no stored phone number.
export const UNMATCHABLE_PHONE_DIGITS = '0'.repeat(16)

/**
 * Builds the Phone filter query the calls endpoints expect: digits only, since
 * the calls query reduces the stored phone and query to digits before comparing
 * them via `build_call_predicates`.
 *
 * A query with no digits can never match a phone number, but the backend drops
 * a blank predicate, so sending "" for input like "unknown" would show the
 * unfiltered list as though every call matched. An impossible run of digits
 * asks for "no match" in the backend's digit-only vocabulary, and the rows and
 * count queries stay in agreement because both derive their filters from
 * this value. Once the backends reject a digit-free phone query outright
 * (Helpcare follow-up), this can collapse back to the digits alone.
 */
export function callsPhoneFilterQuery(input: string): string {
  return normalizePhoneFilterQuery(input) || UNMATCHABLE_PHONE_DIGITS
}

/**
 * Per-field query transforms for the Call Logs table's text filters, passed to
 * `columnFiltersToFilterConditions`.
 *
 * Scoped to this table deliberately. `columnFiltersToFilterConditions` is
 * shared with the Clients, Providers, Visits, Appointments, and Ingestion Runs
 * tables, and the Clients table's Phone filter matches relay's raw
 * `"Phone"[0]->>'phone_number'` text with no digit normalization on the column
 * side — stripping its query to digits would stop punctuated values matching
 * any client whose number is stored unformatted.
 */
export const callsContainsQueryTransforms: Record<
  string,
  (value: string) => string
> = {
  phone: callsPhoneFilterQuery,
}
